import DOMPurify from "dompurify";

// Renderizza i testi editati dallo Staff con markdown + colori, in sicurezza.
// Supportato: **grassetto**, *corsivo*, [testo](https://link), a capo singolo,
// doppio a capo = riga di spazio, <span style="color:#hex">testo</span> (colori,
// prodotto dal selettore dell'editor — e' l'UNICO html che sopravvive).
const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function renderRich(text) {
  if (!text) return "";
  let s = esc(text);
  // 1) marca gli span colore dell'editor (segnaposto invisibili, poi ripristinati)
  s = s.replace(/&lt;span style="color:\s*(#[0-9a-fA-F]{3,8})"&gt;/g, "\x01S$1\x02");
  s = s.replace(/&lt;\/span&gt;/g, "\x01E\x02");
  // 2) link markdown [testo](https://...) — solo http/https, niente javascript:
  s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  // 3) grassetto e corsivo
  s = s.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  s = s.replace(/\*([^*\n]+)\*/g, "<em>$1</em>");
  // 4) a capo: riga vuota = spazio doppio, a capo singolo = <br>
  s = s.replace(/\n{2,}/g, "<br><br>").replace(/\n/g, "<br>");
  // 5) ripristina gli span colore (hex gia' validato dalla regex)
  s = s.replace(/\x01S(#[0-9a-fA-F]{3,8})\x02/g, '<span style="color:$1">').replace(/\x01E\x02/g, "</span>");
  // 6) rete di sicurezza finale: whitelist stretta di tag e attributi
  return DOMPurify.sanitize(s, {
    ALLOWED_TAGS: ["strong", "em", "a", "span", "br"],
    ALLOWED_ATTR: ["href", "target", "rel", "style"],
  });
}

// Testo ricco: se vuoto non renderizza NULLA (niente testo di default)
export const RichText = ({ text, className = "", tag: Tag = "span", ...rest }) => {
  if (!text || !text.trim()) return null;
  return <Tag className={`richtext ${className}`} {...rest} dangerouslySetInnerHTML={{ __html: renderRich(text) }} />;
};

export default RichText;
